import InputField from '../../inputs/inputField'

export default function InstagramForm({
	formData,
	setFormData,
	requiredFields,
	errorFields,
}: {
	formData: any
	setFormData: (data: any) => void
	requiredFields: any[]
	errorFields: any[]
}) {
	const handleDataChange = (name: string, value: string) => {
		let newData = { ...formData }
		newData[name] = value
		setFormData(newData)
	}

	return (
		<div className="flex w-full flex-col gap-y-2">
			<InputField
				name="instagram url"
				type="text"
				placeholder="https://"
				containerWidth="w-full"
				value={formData.url}
				displayRequired={requiredFields.find(field => field.slug == 'url')}
				onChange={e => {
					handleDataChange('url', e.target.value)
				}}
				helper={'Please enter a valid Instagram url'}
				isError={errorFields.find(requiredField => requiredField.slug == 'url')}
			/>
			<InputField
				name="comment"
				lines={4}
				placeholder="Add context to this offchain history signature"
				containerWidth="w-full"
				additionalClasses="h-32"
				value={formData.description}
				displayRequired={requiredFields.find(
					field => field.slug == 'description',
				)}
				onChange={e => {
					handleDataChange('description', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'description',
				)}
			/>
		</div>
	)
}
